<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row custom-table">
        <z-table
          :value="samples"
          sortBy="Timestamp"
          orderBy="asc"
          :columns="tableColumns"
          :isSingleRowDetail="false"
          class="table table-bordered table-striped"
        >
          <template v-slot:tbody="props">
            <td class="z-column-140-right">{{ props.row.Timestamp }}</td>
            <td class="z-column-120-right">{{ props.row.HeartRate }}</td>
            <td class="z-column-140-right">{{ props.row.Duration }}</td>
          </template>
          <template v-slot:empty> Nothing found! </template>
        </z-table>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZTable from '@/Components/ZElements/Table'
export default {
  name: 'samples-dialog',
  components: {
    ZDialog,
    ZTable,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalSize: 'modal-xl',
    }
  },
  emits: ['close'],
  computed: {
    ...mapGetters('usercardio', ['member', 'memberSessionHeartRates']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Heart Rate Samples'
      if (this.member) {
        _title += ` for ${this.member.firstName} ${this.member.lastName}`
      }
      return _title
    },
    tableColumns() {
      return [
        {
          field: 'Timestamp',
          label: 'Timestamp',
          sortable: false,
          class: 'text-end',
        },
        {
          field: 'HeartRate',
          label: 'Heartrate',
          sortable: false,
          class: 'text-end',
        },
        {
          field: 'Duration',
          label: 'Seconds',
          sortable: false,
          class: 'text-end',
        },
      ]
    },
    samples() {
      console.log('Heart Rate Samples', this.memberSessionHeartRates)
      return this.memberSessionHeartRates
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-table {
  max-height: 560px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 15px;
}
</style>
